import constants from '../../../../common/constants';

const banner_types = {
  copy_trader: {
    label: 'Build Your Trading Portfolio',
    value: 'buildyourtradingportfolio',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  education: {
    label: 'Copy Strategies',
    value: 'copystrategies',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  crypto_gaming_stocks: {
    label: 'Copy Strategies Best Traders',
    value: 'copystratsbesttraders',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  goals: {
    label: 'Get Social',
    value: 'getsocial',
    widths: [1080],
    heights: [1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  never_trade_alone: {
    label: 'Pay Stocks',
    value: 'pay0%stockcom',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk],
    countries: ['*'],
  },
  social_investing_network: {
    label: 'Real Stocks Commission',
    value: 'realstock0%commission',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk],
    countries: ['*'],
  },
  spice_up_card_exp: {
    label: 'Real Stocks',
    value: 'realstocks0com',
    widths: [1080],
    heights: [1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk],
    countries: ['*'],
  },
  top_trader: {
    label: 'Trade BTC',
    value: 'tradebtcnaga',
    widths: [1080],
    heights: [1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  welcome_bonus: {
    label: 'Trade like an expert',
    value: 'tradelikeanexpert',
    widths: [1080],
    heights: [1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
  crypto_deposit_bonus: {
    label: 'Unlimited Stocks Trading',
    value: 'unlim0%comstocktrading',
    widths: [160, 300, 300, 728, 970, 970, 1080],
    heights: [600, 250, 600, 90, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk],
    countries: ['*'],
  },
  crypto_deposit_bonus: {
    label: 'What if 1000 USD',
    value: 'whatif1000usd',
    widths: [300, 300, 970, 970, 1080],
    heights: [250, 600, 90, 250, 1080],
    languages: [constants.languages.cz, constants.languages.de, constants.languages.en, constants.languages.es, constants.languages.hu, constants.languages.id, constants.languages.pl, constants.languages.pt, constants.languages.sk, constants.languages.th],
    countries: ['*'],
  },
};

const banner_languages = [constants.languages.en, constants.languages.es, constants.languages.pl, constants.languages.cz, constants.languages.it];

const campaign_selector_form = 'campaignSelectorForm';

export default {
  banner_types,
  banner_languages,
  campaign_selector_form,
};



// WEBPACK FOOTER //
// ./src/app/main/banners/constants/banners-constants.js